import { useState, useEffect } from 'react';
import { Modal, Row, Col, Form } from 'react-bootstrap';
import Select from 'react-select';
import SbCancelBtn, { SbAddBtn, SBAdvanceBtn, SBSaveUpdateBtn } from '../../Buttons/Buttons';
import crossmark from '../../../assets/images/CustomerManagement/crossmark.svg';
import { useDispatch, useSelector } from 'react-redux';
import { loadSettingsFunctionalApprovalData, loadSettingsFunctionalApprovalModuleFieldNameDataforValueFilter, loadSettingsHolidayPolicyData, loadSettingsHolidayPolicyModuleFieldNameDropdown, loadSettingsWorkQueuesRulesData, loadSettingsWorkQueuesRulesModuleFieldNameDataforValueFilter } from '../../../redux/action';
import DatePicker from "react-datepicker";
import moment from 'moment';

const HolidayPolicyValueFilter = ({ showValueFilterModal, handleCloseValueFilterModal, setLoading }) => {

    let dispatch = useDispatch();
    const { getHolidayPolicyModuleFieldDropdown } = useSelector((state) => state.data);

    const [filters, setFilters] = useState([
        { field: null, filterType: 'Value', condition: null, value: '', logic: 'AND', filterCondition: 'Was' }
    ]);
    const [filterText, setFilterText] = useState('');
    const [activeKey, setActiveKey] = useState("0");

    const conditionOptionsForNumbers = [
        { value: '=', label: 'Equal To' },
        { value: '!=', label: 'Not Equal' },
        { value: '>', label: 'Greater Than' },
        { value: '<', label: 'Less Than' },
        { value: '>=', label: 'Greater Than Equal' },
        { value: '<=', label: 'Less Than Equal' },
    ];

    const conditionOptionsForString = [
        { value: 'begins with', label: 'begins with' },
        { value: 'ends with', label: 'ends with' },
        { value: 'contains', label: 'contains' },
    ]

    const conditionOptionsForDate = [
        { value: '=', label: 'Equal To' },
        { value: '<', label: 'Less Than' },
        { value: '<=', label: 'Less Than Equal To' },
        { value: '>', label: 'Greater Than' },
        { value: '>=', label: 'Greater Than Equal To' },
    ]

    const setTypeOptions = [
        { value: 'Value', label: 'Value' },
        { value: 'Fields', label: 'Fields' },
    ];

    // Update filter when a field changes
    const handleFilterChange = (index, field, value) => {
        const updatedFilters = [...filters];
        updatedFilters[index][field] = value;
        setFilters(updatedFilters);
    };

    // Add a new filter when "Add Filter" is clicked
    const handleAddFilter = () => {
        const newIndex = filters.length;
        const newFilter = { field: null, filterType: 'Value', condition: null, value: '', logic: 'AND', filterCondition: 'Was' };
        setFilters([...filters, newFilter]);
        setActiveKey(String(newIndex));

        // Generate the filter text only when "Add Filter" is clicked
        generateFilterText([...filters, newFilter]);
    };

    // Reset all filters to the initial state
    const resetState = () => {
        setFilters([{ field: null, filterType: 'Value', condition: null, value: '', logic: 'AND', filterCondition: 'Was' }]);
        setFilterText('');
        setActiveKey("0");
    };

    // Generate filter text when a new filter is added
    const generateFilterText = (updatedFilters) => {
        let text = '';
        updatedFilters.forEach((filter, index) => {
            if (filter.field && filter.condition && filter.value) {
                const logic = index > 0 ? `${filter.logic} ` : '';
                const condition = filter.condition?.label || '';
                const filterCondition = filter.filterCondition || '';
                const filterValue = filter.value || '';
                const fieldName = filter.field?.label || '';

                text += `${logic}${fieldName} ${filterCondition} ${condition} "${filterValue}"\n`;
            }
        });
        setFilterText(text.trim());
    };

    useEffect(() => {
        dispatch(loadSettingsHolidayPolicyModuleFieldNameDropdown());
    }, []);

    const [whereClause, setWhereClause] = useState('');
    // Generate whereClause when filters change
    // const generateWhereClause = () => {
    //     let whereClause = '';

    //     filters.forEach((filter, index) => {
    //         if (filter.field && filter.condition && filter.value) {
    //             const logic = index > 0 ? ` ${filter.logic} ` : ''; // Add logic for subsequent filters
    //             const fieldName = filter.field.value; // The field's value
    //             const condition = filter.condition.value; // The condition (e.g., "equal to")
    //             const value = filter.value; // The value entered by the user
    //             const clause = `${fieldName} ${condition} '${value}'`;
    //             whereClause += `${logic}${clause}`; // Concatenate with logic (AND/OR)
    //         }
    //     });

    //     setFilterText(whereClause); // Set the whereClause as filterText to display
    //     console.log(whereClause, 'whereClause')
    // };

    // const generateWhereClause = () => {
    //     let whereClause = '';

    //     filters.forEach((filter, index) => {
    //         if (filter.field && filter.condition && filter.value) {
    //             const logic = index > 0 ? ` ${filter.logic} ` : ''; // Add logic for subsequent filters
    //             const fieldName = filter.field.value; // The field's value
    //             const condition = filter.condition.value; // The condition (e.g., "equal to")
    //             const value = filter.value; // The value entered by the user

    //             // Check if the field is a number or a string
    //             const selectedField = customerModuleFieldDropdownData.find(
    //                 (field) => field.value === filter.field.value
    //             );

    //             // Default the value to be wrapped in quotes for strings
    //             let formattedValue = value;

    //             // If the selected field is a number, don't wrap in quotes
    //             if (selectedField && selectedField.columnDataType === 'number') {
    //                 formattedValue = value; // No quotes for numbers
    //             } else {
    //                 formattedValue = `"${value}"`; // Wrap string values in quotes
    //             }

    //             const clause = `${fieldName} ${condition} ${formattedValue}`;
    //             whereClause += `${logic}${clause}`; // Concatenate with logic (AND/OR)
    //         }
    //     });

    //     setFilterText(whereClause); // Set the whereClause as filterText to display
    //     console.log(whereClause, 'whereClause');
    // };

    const generateWhereClause = () => {
        let whereClause = '';

        // Separate filters by AND and OR conditions
        const andConditions = [];
        const orConditions = [];

        filters.forEach((filter, index) => {
            if (filter.field && filter.condition && filter.value) {
                const logic = index > 0 ? ` ${filter.logic} ` : ''; // Add logic for subsequent filters
                const fieldName = filter.field.value; // The field's value
                let condition = filter.condition.value; // The condition (e.g., "equal to", "not equal")
                const value = filter.value; // The value entered by the user

                // Find the selected field in the field data
                const selectedField = getHolidayPolicyModuleFieldDropdown.find(
                    (field) => field.value === filter.field.value
                );

                // Default the value to be wrapped in quotes for strings
                let formattedValue = value;

                // Handle the "Not" condition and the different column data types
                if (selectedField && selectedField.columnDataType === 'number') {
                    formattedValue = value; // No quotes for numbers

                    // For "Not" conditions with numbers, use '!='
                    if (filter.filterCondition === 'Not') {
                        condition = '!='; // Use != for "Not" condition with numbers
                    }
                } else if (selectedField && selectedField.columnDataType === 'string') {
                    // Handle string conditions specifically for LIKE/!LIKE
                    if (condition === 'begins with') {
                        formattedValue = `'${value}%'`; // "Value%" for "begins with"
                        condition = 'LIKE'; // Change the condition to LIKE for "begins with"
                    } else if (condition === 'ends with') {
                        formattedValue = `'%${value}'`; // "%Value" for "ends with"
                        condition = 'LIKE'; // Change the condition to LIKE for "ends with"
                    } else if (condition === 'contains') {
                        formattedValue = `'%${value}%'`; // "%Value%" for "contains"
                        condition = 'LIKE'; // Change the condition to LIKE for "contains"
                    } else {
                        formattedValue = `'${value}'`; // Direct string match for "="
                        condition = '='; // For exact match condition
                    }

                    // Apply !LIKE for the "Not" condition (for strings only)
                    if (filter.filterCondition === 'Not') {
                        condition = 'NOT LIKE'; // Use !LIKE instead of NOT LIKE for string fields
                    }
                } else if (selectedField && selectedField.columnDataType === 'date') {
                    // Convert the date to the format 'DD-MMM-YYYY' (e.g., '04-Jan-2025')
                    const formattedDate = moment(value, 'DD/MM/YYYY').format('DD-MMM-YYYY');
                    formattedValue = `'${formattedDate}'`;

                    // For "Not" condition with dates, use '!='
                    if (filter.filterCondition === 'Not') {
                        condition = '!='; // Use != for "Not" condition with dates
                    }

                    // For date fields, format as SQL CONVERT function
                    formattedValue = `CONVERT(DATE, '${formattedDate}', 101)`;
                }

                // Build the clause based on the condition type
                let clause = '';

                if (selectedField) {
                    // Check if the field is one of the specified types and prepend the corresponding alias
                    if (selectedField.value === 'CountryCode_Name') {
                        clause = `c.${fieldName}`; // Prefix with 'm.'
                    }

                    // Check the column data type and build the clause accordingly
                    if (selectedField.columnDataType === 'string' && selectedField.value === 'Status_Status') {
                        clause = `s.${fieldName} ${condition} ${formattedValue}`;
                    } else if (selectedField.columnDataType === 'string') {
                        clause = `h.${fieldName} ${condition} ${formattedValue}`;
                    } else if (selectedField.columnDataType === 'number') {
                        clause = `h.${fieldName} ${condition} ${formattedValue}`;
                    } else if (selectedField.columnDataType === 'date') {
                        clause = `CONVERT(DATE, h.${fieldName}, 101) ${condition} ${formattedValue}`;
                    }
                }

                // Add the clause to the appropriate conditions array (AND/OR)
                if (filter.logic === 'OR') {
                    orConditions.push(clause);
                } else {
                    andConditions.push(clause);
                }
            }
        });

        // Combine AND conditions with OR conditions, wrapping OR conditions in parentheses
        if (orConditions.length > 0) {
            whereClause += `(${orConditions.join(' OR ')})`;
        }
        if (andConditions.length > 0) {
            if (whereClause) {
                whereClause += ' AND ';
            }
            whereClause += andConditions.join(' AND ');
        }

        setFilterText(whereClause); // Set the whereClause as filterText to display
        console.log(whereClause, 'whereClause');
    };

    // Recalculate whereClause whenever filters change
    useEffect(() => {
        generateWhereClause();
    }, [filters]);

    // Determine which condition options to show based on the selected field's type
    const getConditionOptions = () => {
        const selectedField = filters[activeKey]?.field;
        if (selectedField) {
            const selectedFieldData = getHolidayPolicyModuleFieldDropdown.find(
                (field) => field.value === selectedField.value
            );

            if (selectedFieldData) {
                switch (selectedFieldData.columnDataType) {
                    case 'string':
                        return conditionOptionsForString;
                    case 'number':
                        return conditionOptionsForNumbers;
                    case 'date':
                        return conditionOptionsForDate;
                    default:
                        return [];
                }
            }
        }
        return conditionOptionsForNumbers; // Default to numbers if no type matches
    };

    // Date picker handling: checking the columnDataType
    // In your renderValueField function

    const renderValueField = (activeKey) => {
        const selectedFilter = filters[activeKey];
        if (!selectedFilter) return null;

        const selectedField = selectedFilter.field; // Ensure you're accessing the 'field' object, not 'filterType'

        // Check if the selected field is a valid object and exists
        if (selectedField && selectedField.columnDataType === 'date') {
            return (
                <DatePicker
                    className="select from-date"
                    id="date-range-picker"
                    dateFormat="dd/MM/yyyy"
                    selected={selectedFilter.value ? new Date(selectedFilter.value) : null}
                    onChange={(date) => handleFilterChange(activeKey, 'value', date)}
                    showMonthDropdown
                    showYearDropdown
                    selectsRange={false}
                    placeholderText="DD/MM/YYYY"
                // maxDate={new Date()}
                />
            );
        }

        // Handle 'Fields' filter type for Select dropdown
        if (selectedFilter.filterType && selectedFilter.filterType.value === 'Fields') {
            // Define alias mapping
            const aliasMap = {
                CountryCode_Name: 'c.',
                // Levels_Name: 'l.',
                // SubModules_Name: 'SM.',
                Status_Status: 's.',
            };

            // Find the selected option and prepend the alias if necessary
            const selectedOption = getHolidayPolicyModuleFieldDropdown.find(
                (option) =>
                    `${aliasMap[option.value] || 'h.'}${option.value}` === selectedFilter.value
            );

            return (
                <Select
                    className="react-select-container"
                    classNamePrefix="react-select"
                    options={getHolidayPolicyModuleFieldDropdown}
                    placeholder="Select Field"
                    onChange={(option) => {
                        const alias = aliasMap[option.value] || 'h.'; // Get the alias or default to 'WQ.'
                        handleFilterChange(activeKey, 'value', `${alias}${option.value}`); // Prepend alias
                    }}
                    value={selectedOption || null} // Match selected option with prepended alias
                    menuPosition="fixed"
                    menuShouldScrollIntoView={false}  // Prevents auto-scrolling issues
                />
            );
        }

        // Render text input for non-date fields
        return (
            <Form.Control
                type="text"
                placeholder="Enter value"
                value={selectedFilter.value}
                onChange={(e) => handleFilterChange(activeKey, 'value', e.target.value)}
            />
        );
    };

    const handleSave = () => {
        const whereClause = filterText;
        // console.log(whereClause, 'whereClausewhereClausewhereClause')
        dispatch(loadSettingsHolidayPolicyData(setLoading, null, null, whereClause,));
        handleCloseValueFilterModal();
    }

    return (
        <Modal show={showValueFilterModal} onHide={() => { handleCloseValueFilterModal(); resetState(); }} className='value-filter-modal add-customer-modal' centered>
            <Modal.Header closeButton>
                <Modal.Title>Value Filter</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Row className='pb-2'>
                    <Col>
                        <div className="value-filter-btn-div">
                            <SBSaveUpdateBtn btnName="Basic" />
                            <SBAdvanceBtn btnName="Advance" />
                        </div>
                    </Col>
                </Row>

                {/* Add Filter Section */}
                <Row className="mt-3">
                    <p>Add Filter</p>
                    <Col md={6}>
                        <p>Select Field</p>
                        <Select
                            className="react-select-container"
                            classNamePrefix="react-select"
                            options={getHolidayPolicyModuleFieldDropdown}
                            placeholder="Select"
                            onChange={(option) => handleFilterChange(activeKey, 'field', option)}
                            value={filters[activeKey].field}
                            menuPosition="fixed"
                            menuShouldScrollIntoView={false}  // Prevents auto-scrolling issues
                        />
                    </Col>
                </Row>

                <Row>
                    <Col md={6}>
                        <div className="customer-value-filter-checkbox-group mt-3">
                            <Form.Check
                                type="radio"
                                label="Was"
                                checked={filters[activeKey].filterCondition === 'Was'}
                                onChange={() => handleFilterChange(activeKey, 'filterCondition', 'Was')}
                            />
                            <Form.Check
                                type="radio"
                                label="Not"
                                checked={filters[activeKey].filterCondition === 'Not'}
                                onChange={() => handleFilterChange(activeKey, 'filterCondition', 'Not')}
                            />
                        </div>
                    </Col>
                </Row>

                <Row className="mt-3">
                    <Col md={4}>
                        <p>Set Condition</p>
                        <Select
                            className="react-select-container"
                            classNamePrefix="react-select"
                            // options={conditionOptionsForNumbers}
                            options={getConditionOptions()}
                            placeholder="Condition"
                            value={filters[activeKey].condition}
                            onChange={(option) => handleFilterChange(activeKey, 'condition', option)}
                            menuPosition="fixed"
                            menuShouldScrollIntoView={false}  // Prevents auto-scrolling issues
                        />
                    </Col>
                    <Col md={4}>
                        <p>Set Type</p>
                        <Select
                            className="react-select-container"
                            classNamePrefix="react-select"
                            options={setTypeOptions}
                            placeholder="Select Type"
                            value={filters[activeKey].filterType} // This should match the filterType object, not just its value.
                            onChange={(option) => handleFilterChange(activeKey, 'filterType', option)} // Pass the entire option object.
                            menuPosition="fixed"
                            menuShouldScrollIntoView={false}  // Prevents auto-scrolling issues
                        />
                    </Col>
                    <Col md={4} className='value-filter-text-add-div'>
                        {/* <Form.Control
                            type="text"
                            placeholder="Enter value"
                            value={filters[activeKey].value}
                            onChange={(e) => handleFilterChange(activeKey, 'value', e.target.value)}
                        /> */}
                        {renderValueField(activeKey)}  {/* Render the DatePicker or TextField */}
                    </Col>
                    {/* <Col md={2} className='value-filter-text-add-div'>
                        <p></p>
                        <SbAddBtn btnName="Add Filter" onClickEffect={handleAddFilter} />
                    </Col> */}
                </Row>

                <Row className="mt-3">
                    <Col className='value-filter-radio-btn-div'>
                        <Form.Check
                            type="radio"
                            label="AND"
                            value="AND"
                            checked={filters[activeKey].logic === 'AND'}
                            onChange={() => handleFilterChange(activeKey, 'logic', 'AND')}
                        />
                        <Form.Check
                            type="radio"
                            label="OR"
                            value="OR"
                            checked={filters[activeKey].logic === 'OR'}
                            onChange={() => handleFilterChange(activeKey, 'logic', 'OR')}
                        />
                    </Col>
                </Row>
                <Row className="mt-3">
                    <Col md={2} className='value-filter-text-add-div'>
                        <p></p>
                        <SbAddBtn btnName="Add Filter" onClickEffect={handleAddFilter} />
                    </Col>
                </Row>

                {/* Textarea for displaying filter conditions */}
                <Row className="mt-3">
                    <Col md={12}>
                        <div className="filter-textarea">
                            {filterText && (
                                <img
                                    src={crossmark}
                                    alt="Delete filter"
                                    className='filter-delete-img'
                                    onClick={resetState}
                                    style={{ cursor: 'pointer', marginRight: '10px' }}
                                />
                            )}
                            <textarea
                                rows={3}
                                placeholder="Filter conditions will appear here..."
                                value={filterText}
                                readOnly
                                style={{
                                    border: 'none',
                                    outline: 'none',
                                    flex: 1,
                                    resize: 'none',
                                    background: 'transparent'
                                }}
                            />
                        </div>
                    </Col>
                </Row>
            </Modal.Body>

            <Modal.Footer>
                <SbCancelBtn btnName="Cancel" onClickEffect={() => { handleCloseValueFilterModal(); resetState(); }} />
                <SBSaveUpdateBtn btnName="Apply" onClickEffect={handleSave} />
            </Modal.Footer>
        </Modal>
    );
};

export default HolidayPolicyValueFilter;
